import Vue from 'vue'
import store from '@/config/vuex'
import VueRouter from 'vue-router'
import routes from './routes.js'
import ROUTE_NAMES from './route-names'
import {
  notifyExternalServices,
  ACTIONS,
} from '@/services/external-communication/external-communication'
import { GIFT_CARDS_VIRT_PATH } from '@/config/constants'

Vue.use(VueRouter)

/**
 * Parses location.pathname to retrieve base path by using the language part.
 * E.g. for "/de-de/checkout" it would use "/de-de/" as base path.
 */
function getAppBase() {
  const p = window.location.pathname.split('/')
  return p[1] ? `/${p[1]}/` : '/'
}

const router = new VueRouter({
  mode: 'history',
  base: getAppBase(), // base for vue routing (everything beyond base path will be handled by vue router)
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition // Keep saved position when the browser's back and forward button is used
    } else if (to.name !== from.name) {
      return { x: 0, y: 0 } // Scroll to top of the screen when a route change happens
    }
  },
})

router.beforeEach((to, from, next) => {
  // Initial page load must not be reported as virtPath
  if (from.name === null) return next()

  const isTrackingVirtPathInView = to.matched.some(record => record.meta.isTrackingVirtPathInView)
  const isCheckout = to.matched.some(record => record.name === ROUTE_NAMES.checkout)
  const isGiftCardOrder = store.getters['order/isGiftCardOrder']
  const virtPagePath = isCheckout && isGiftCardOrder ? GIFT_CARDS_VIRT_PATH + to.path : to.path

  if (!isTrackingVirtPathInView) {
    notifyExternalServices({
      action: ACTIONS.virtPath,
      details: {
        virtPagePath: virtPagePath,
        virtPageTitle: document.title,
      },
    })
  }
  next()
})

router.afterEach(() => {
  Vue.$dyClient.updateHistoryState()
})

export default router
